var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillRule: "nonzero",
    points: "6.20410932 12.7874193 2.36690889 8.95021885 1.06483729 10.2522905 6.20410932 15.3915625 17.2464127 4.34925911 15.9443411 3.0471875"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickicon);
export default __webpack_public_path__ + "static/media/tickicon.d5e63065dc09c0a4a1fa85c2e9cc5294.svg";
export { ForwardRef as ReactComponent };